module.exports = __webpack_public_path__ + "img/10.4fec470b.jpg";